import { axios, fileAxios } from '../../plugins/axios'
import { axios as axiosPol } from '../../plugins/axios-pol'

export default {
  namespaced: true,

  state: {
    biometricosPersonal: [],
    biometricoToUpdate: null,
  },

  getters: {
    getBiometricosPersonal: (state) => {
      return state.biometricosPersonal
    },
  },

  mutations: {
    SET_BIOMETRICOS_PERSONAL(state, biometricosPersonal) {
      state.biometricosPersonal = biometricosPersonal
    },

    // SET_AULA_TO_UPDATE(state, biometricoId) {
    //     var biometricoToUpdate = state.biometricos.filter(biometrico => {
    //         return biometrico.id == biometricoId
    //     })

    //     var biometrico = _.cloneDeep(biometricoToUpdate[0])

    //     state.biometricoToUpdate = biometrico
    // },
  },

  actions: {
    fetchBiometricosPersonal: async function ({ commit }, idPersonal) {
      await axiosPol
        .get('/personal/api/EstadoFuerza/personal/' + idPersonal + '/biometricos')
        .then((response) => {
          commit('SET_BIOMETRICOS_PERSONAL', response.data.data)
        })
        .catch((error) => console.log(error))
    },

    saveBiometricoPersonal: async function (context, biometrico) {
      const response = await axios.post(
        '/EonCloud/EstadoFuerza/personal/' + biometrico.fk_idPersonal + '/biometricos',
        biometrico
      )
      const formData = new FormData()
      formData.append('file', biometrico.file)
      formData.append('idBiometricoPersonal', response.data.data[0].ID)
      await context.dispatch('uploadBiometrico', formData)
    },

    updateBiometrico: async function (context, biometrico) {
      await axios.put('/EonCloud/EstadoFuerza/personal/' + biometrico.fk_idPersonal + '/biometricos', biometrico)
      const formData = new FormData()
      formData.append('file', biometrico.file)
      formData.append('idBiometricoPersonal', biometrico.id)
      await context.dispatch('uploadBiometrico', formData)
    },

    uploadBiometrico: async function (context, formData) {
      await fileAxios.post('/Biometrico/uploadFiles', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
      context.commit('SET_SNACKBAR_MESSAGE', 'Captura de biométrico guardada correctamente.', { root: true })
    },

    deleteBiometrico: async function (context, idBiometrico) {
      try {
        const response = await axiosPol.put(
          '/personal/api/EstadoFuerza/personal/biometricos/' + idBiometrico + '/delete'
        )
        if (response.data && response.data.result === false) {
          throw new Error(response.data.error_message || 'No se pudo eliminar el biométrico.')
        }
        context.commit('SET_SNACKBAR_MESSAGE', 'Biométrico eliminado correctamente.', { root: true })
      } catch (error) {
        context.commit('SET_SNACKBAR_MESSAGE', 'Ocurrió un error al eliminar el biométrico.', { root: true })
        throw error
      }
    },
  },
}
